import * as React from 'react'
import BedbankPriceChangeModal from 'checkout/Components/Booking/Modals/BedbankPriceChangeModal'

export const BedbankPriceChangeModalContext = React.createContext<() => Promise<number>>(undefined)

export function BedbankPriceChangeModalProvider({ children }) {
  const [isOpen, setOpenModal] = React.useState<boolean>(false)

  const awaitingPromiseRef = React.useRef<{
    resolve:(newPrice: number) => void;
    reject: () => void;
  }>()

  const openModal = React.useCallback(() => {
    setOpenModal(true)
    return new Promise<number>((resolve, reject) => {
      awaitingPromiseRef.current = { resolve, reject }
    })
  }, [])

  const handleClose = () => {
    setOpenModal(false)
    awaitingPromiseRef.current?.reject()
  }

  const onAccept = (newPrice: number) => {
    setOpenModal(false)
    awaitingPromiseRef.current?.resolve(newPrice)
  }
  return (
    <>
      <BedbankPriceChangeModalContext.Provider
        value={openModal}
        children={children}
      />
      <BedbankPriceChangeModal
        onClose={handleClose}
        onAccept={onAccept}
        isOpen={isOpen}
      />
    </>
  )
}
